function Footer() {
  return (
    <footer className="container text-center my-5">
      <p>&copy; 2025</p>
    </footer>
  );
}

export default Footer;
